import React, { useEffect, useState } from "react";
import Slidere from "./Slider";
import Dealsoftheday from "./Dealsoftheday";
import Banner from "./Banner";
import Security from "./Security";
import Footer from "./Footer";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import FruitsandVagetables from "./FruitsandVagetables";
import Manubar from "./Manubar";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import baseurl from "./Baseurl";
import "./header.css";

const Header = () => {
  const [profile, setProfile] = useState(null);
  const _id = secureLocalStorage.getItem("n_id");
  const token = secureLocalStorage.getItem("n_token");

  useEffect(() => {
    if (!_id || !token) return;

    const fetchProfile = async () => {
      try {
        const { data } = await axios.post(
          `${baseurl[0].apiurl}get_user_profile`,
          { user_id: _id },
          { headers: { token } }
        );

        if (data?.result) {
          setProfile(data.data);
        } else {
          console.warn("Profile fetch failed:", data?.msg);
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchProfile();
  }, [_id, token]);

  return (
    <>
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header>
        <Shearchbar userProfile={profile} />
        <Navbar />
      </header>

      <main style={{ width: "100%", margin: "0 auto" }}>
        <Slidere />
        <Dealsoftheday />
        <FruitsandVagetables />
        <Banner />
      </main>

      <Security />
      <Footer />
    </>
  );
};

export default Header;
